import React from 'react';
import ReactDOM from 'react-dom';

import './main.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css'

import Container from 'react-bootstrap/Container';

import { Startup } from "./startup";
import { Players } from "./players";
import { Article } from "./article";
import { Waiting } from "./waiting";
import { Game } from "./game";
import { Error } from "./error"
import { Kicked } from "./kick"

Array.prototype.remove = function () {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

let getLogData;

class GameFrame extends React.Component {
    constructor(props) {
        super(props);

        this.logData = ""

        this.socket = new WebSocket('wss://motpal-api.symlix.fr');

        let realSend = this.socket.send.bind(this.socket);
        this.socket.send = (x) => {
            this.log("network_out", x);
            return realSend(x)
        };

        this.pinger = setInterval(() => {
            realSend("!"); // ping the server every 2 seconds
        }, 2000);

        getLogData = () => this.logData;

        this.startupError = "";

        this.onNetworkMessage = this.onNetworkMessage.bind(this);
        this.onChangeJudge = this.onChangeJudge.bind(this);
        this.onKick = this.onKick.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onRevealAnswer = this.onRevealAnswer.bind(this);
        this.onAdmin = this.onAdmin.bind(this);
        this.onPlay = this.onPlay.bind(this);

        this.pongTimeout = setTimeout(() => {
            this.socket.terminate();
            this.scene = "error";
            this.forceUpdate();
        }, 6000);

        this.socket.onmessage = this.onNetworkMessage;

        this.socket.onerror = (e) => {
            this.scene = "error";
            clearTimeout(this.pongTimeout);
            clearInterval(this.pinger);
            this.log("ws_error", JSON.stringify(e));
            this.forceUpdate();
        };

        this.socket.onclose = (e) => {
            this.scene = (this.scene == "kicked") ? "kicked" : "error";
            clearTimeout(this.pongTimeout);
            clearInterval(this.pinger);
            this.log("ws_close", JSON.stringify(e));
            this.forceUpdate();
        };
    }

    log(x, y) {
        this.logData += x + "\n" + y + "\n\n"
        console.log(x)
        console.log(y)
    }

    componentWillMount() {
        this.scene = "startup"
    }

    onNetworkMessage(evt) {
        if (this.scene == "error" || this.scene == "kicked") return;

        if (evt.data == "!") { // pong
            clearTimeout(this.pongTimeout);
            
            this.pongTimeout = setTimeout(() => {
                this.socket.terminate();
                this.scene = "error";
                this.forceUpdate();
            }, 6000);

            return;
        }
        
        const msg = JSON.parse(evt.data);

        this.log("network_in", evt.data);

        switch (msg.kind) {
            case "startupError":
                this.startupError = msg.error;
                this.forceUpdate();
                break;

            case "start":
                this.gameInfo = msg.gameInfo;
                this.self = msg.self;
                this.scene = "players";
                this.shownAuthor = false;
                this.shownArticle = false;
                this.forceUpdate();
                break;

            case "kicked":
                this.scene = "kicked";
                clearTimeout(this.pongTimeout);
                clearInterval(this.pinger);
                this.forceUpdate();
                break;

            case "waitingFor":
                if (this.scene == "players") {
                    this.scene = (this.self == this.gameInfo.judge ? "waiting" : "article");
                }
                this.waitingFor = msg.waitingFor;
                this.forceUpdate();
                break;

            case "article":
                this.pickedArticle = msg.pickedArticle;
                if (this.pickedArticle.article == this.articleTitle) {
                    this.articleTitle = undefined;
                    this.articleUrl = undefined;
                }
                this.scene = "game";
                this.forceUpdate();
                break;

            case "revealArticle":
                this.shownArticle = true;
                this.forceUpdate();
                break;

            case "revealAuthor":
                this.shownAuthor = true;
                this.forceUpdate();
                break;

            case "panic":
                this.scene = "error";
                clearTimeout(this.pongTimeout);
                clearInterval(this.pinger);
                this.forceUpdate();
                break;
        }
    }

    onChangeJudge(judge) {
        this.gameInfo.judge = judge;
        this.forceUpdate();
    }

    onKick(playerId) {
        this.gameInfo.players.splice(playerId, 1);
        this.forceUpdate();
    }

    onAdmin(admin) {
        this.gameInfo.admin = admin;
        this.forceUpdate();
    }

    onPlay() {
        this.scene = this.gameInfo.judge == this.self ? "waiting" : "article";
        this.waitingFor = this.gameInfo.players.filter((x) => (x != this.self));

        this.socket.send(JSON.stringify({ "kind": "play" }));
        this.forceUpdate();
    }

    onCancel() {
        this.scene = "players";
        this.forceUpdate();
    }

    onRevealAnswer() {
        this.shownAuthor = true;
        this.forceUpdate();
    }

    render() {
        let scene;

        switch (this.scene) {
            case "startup":
                scene = <Container className="h-100" >
                    <Startup
                        error={this.startupError}
                        socket={this.socket}
                    />
                </Container>;
                break;

            case "players":
                scene = <Container className="h-100" >
                    <Players
                        code={this.gameInfo.code}
                        players={this.gameInfo.players}
                        self={this.self}
                        admin={this.gameInfo.admin == this.self}
                        selected={this.gameInfo.judge}
                        onChangeJudge={this.onChangeJudge}
                        onAdmin={this.onAdmin}
                        onPlay={this.onPlay}
                        onKick={this.onKick}
                        socket={this.socket}
                    />
                </Container>;
                break;

            case "article":
                scene = <Article
                    socket={this.socket}
                    onSelect={(articleTitle, articleUrl) => { this.articleTitle = articleTitle; this.articleUrl = articleUrl; this.scene = "waiting"; this.forceUpdate(); }}
                    articleTitle={this.articleTitle}
                    articleUrl={this.articleUrl}
                />
                break;

            case "waiting":
                scene = <Container className="h-100" >
                    <Waiting
                        waitingFor={this.waitingFor}
                        judgeName={this.gameInfo.judge}
                        judge={this.gameInfo.judge == this.self}
                        admin={this.gameInfo.admin == this.self}
                        onCancel={this.onCancel}
                        socket={this.socket}
                    />
                </Container>;
                break;

            case "game":
                scene = <Container className="h-100" >
                    <Game
                        judge={this.gameInfo.judge == this.self}
                        admin={this.gameInfo.admin == this.self}
                        word={this.pickedArticle.article}
                        answer={this.pickedArticle.author}
                        ended={this.shownAuthor}
                        shown={this.shownArticle}
                        onRevealAnswer={this.onRevealAnswer}
                        onCancel={this.onCancel}
                        socket={this.socket}
                    />
                </Container>;
                break;

            case "error":
                scene = <Error />
                break;

            case "kicked":
                scene = <Kicked />
                break;
        }

        return <>{scene}</>;
    }
}

ReactDOM.render(
    <GameFrame />,
    document.getElementById('root')
);